import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { NotificationHelper } from '../../../helpers/notification.helper';
import { DialogButton } from '../../../models/enums/dialogbutton.enum';
import { WebHookService } from '../../../services/webhook.service';
import { BaseDialog } from '../basedialog/base.dialog';

@Component({
    selector: 'webhook-dialog',
    templateUrl: './webhook.dialog.html',
    styleUrls: ['./webhook.dialog.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebHookDialog {

    result;
    _Name = "";
    @Input()
    get Name() {
        return this._Name;
    }
    set Name(val) {
        this._Name = val;
    }

    HasChanges = false;
    CustomButtons = [{
        Caption: '@@Speichern',
        ID: 0
    }, {
        Caption: '@@Abbrechen',
        ID: 1
    }];
    CloseOnCustomButton = true;
    Loading = true;

    public static ShowDialog(handler) {
        BaseDialog.ShowDialog({
            ContentType: WebHookDialog,
            InitArgs: null,
            Title: '@@Neuer Webhook anlegen',
            Buttons: DialogButton.None,
            Handler: handler
        });
    }

    constructor(private service: WebHookService) {
    }

    GetDialogResult() {
        return this.result;
    }

    async OnCustomButtonClicked(button) {
        this.result = null;
        if (button && button.ID === 0) {
            if (this.Name !== "") {
                const retVal = await firstValueFrom(this.service.SaveNew(this._Name));
                if (retVal) {
                    this.result = {
                        Key: retVal.AdditionalInfos[0],
                        Name: retVal.Caption,
                        SID: retVal.SID
                    };
                    NotificationHelper.Success('@@Webhookkey:' + this.result['Key'], '@@Webhooksetting has been successfully saved');
                }
            }
        }
    }
}
